// extracted by mini-css-extract-plugin
export var colorSquare = "_ug-0";
export var danger = "_ug-5";
export var lightPink = "_ug-8";
export var neutralBlue = "_ug-7";
export var neutralYellow = "_ug-6";
export var normal = "_ug-1";
export var primary = "_ug-2";
export var primaryLight = "_ug-3";
export var solidBlack = "_ug-g";
export var solidGreen = "_ug-b";
export var solidLightBlue = "_ug-d";
export var solidNavy = "_ug-c";
export var solidOrange = "_ug-f";
export var solidPink = "_ug-e";
export var solidRed = "_ug-9";
export var solidYellow = "_ug-a";
export var success = "_ug-4";